import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './Skeletons.css';

const StatCardSkeleton = () => (
  <div className="skeleton-card metric-card-skeleton">
    <div className="d-flex justify-content-between mb-2">
      <div className="skeleton skeleton-title" style={{ width: '60%' }} />
      <div className="skeleton skeleton-icon" />
    </div>
    <div className="skeleton skeleton-text lg" />
    <div className="skeleton skeleton-text md" />
    <div className="d-flex justify-content-between mt-3">
      <div className="skeleton skeleton-text sm" style={{ width: '40%' }} />
      <div className="skeleton skeleton-badge" style={{ width: '25%' }} />
    </div>
  </div>
);

const LeadSourcesSkeleton = () => (
  <div className="skeleton-card lead-sources-skeleton">
    <div className="d-flex justify-content-between mb-3">
      <div className="skeleton skeleton-title" style={{ width: '50%' }} />
      <div className="skeleton skeleton-badge" style={{ width: '20%' }} />
    </div>
    <div className="skeleton skeleton-chart" style={{ height: '120px' }} />
    <div className="skeleton-table">
      {[1, 2, 3].map((i) => (
        <div key={i} className="d-flex justify-content-between mb-2">
          <div className="skeleton skeleton-text md" style={{ width: '40%' }} />
          <div className="skeleton skeleton-text sm" style={{ width: '20%' }} />
        </div>
      ))}
    </div>
  </div>
);

const ContactsBySourceSkeleton = () => (
  <div className="skeleton-card contacts-by-source-skeleton">
    <div className="d-flex justify-content-between mb-3">
      <div className="skeleton skeleton-title" style={{ width: '60%' }} />
      <div className="skeleton skeleton-badge" style={{ width: '15%' }} />
    </div>
    <div className="skeleton skeleton-chart" style={{ height: '200px' }} />
    <div className="skeleton-table">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="d-flex justify-content-between mb-2">
          <div className="skeleton skeleton-text md" style={{ width: '30%' }} />
          <div className="skeleton skeleton-text sm" style={{ width: '15%' }} />
        </div>
      ))}
    </div>
  </div>
);

const AIGreetingCardSkeleton = () => (
  <div className="skeleton-card ai-greeting-card">
    <div className="d-flex gap-3">
      <div className="skeleton skeleton-icon" style={{ borderRadius: '12px' }} />
      <div className="flex-grow-1">
        <div className="skeleton skeleton-text md mb-2" style={{ width: '80%' }} />
        <div className="skeleton skeleton-text sm" style={{ width: '60%' }} />
      </div>
    </div>
  </div>
);

const RecommendationCardSkeleton = () => (
  <div className="skeleton-card" style={{ height: '120px' }}>
    <div className="d-flex justify-content-between mb-2">
      <div className="skeleton skeleton-text md" style={{ width: '70%' }} />
      <div className="skeleton skeleton-icon" style={{ width: '24px', height: '24px' }} />
    </div>
    <div className="skeleton skeleton-text sm mb-3" style={{ width: '90%' }} />
    <div className="d-flex justify-content-between align-items-center">
      <div className="skeleton skeleton-text sm" style={{ width: '40%' }} />
      <div className="skeleton skeleton-badge" style={{ width: '20%', height: '20px' }} />
    </div>
  </div>
);

const AIRecommendationsSkeleton = () => (
  <div className="skeleton-card ai-recommendations-skeleton">
    <div className="d-flex justify-content-between mb-3">
      <div className="skeleton skeleton-title" style={{ width: '50%' }} />
      <div className="skeleton skeleton-badge" style={{ width: '15%' }} />
    </div>
    <div className="skeleton-recommendations">
      <RecommendationCardSkeleton />
      <RecommendationCardSkeleton />
      <RecommendationCardSkeleton />
    </div>
  </div>
);

const CrmDashboardSkeleton = () => {
  return (
    <div className="enhanced-crm-dashboard">
      <div className="dashboard-header-enhanced mb-4">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="skeleton skeleton-header" />
          <div className="d-flex gap-2">
            <div className="skeleton skeleton-badge" />
            <div className="skeleton skeleton-badge" />
          </div>
        </div>
        <div className="skeleton skeleton-text md" style={{ width: '40%' }} />
      </div>

      <AIGreetingCardSkeleton />
      
      {/* <div className="d-flex flex-wrap gap-2 mb-4">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="skeleton" style={{ width: '100px', height: '36px', borderRadius: '12px' }} />
        ))}
      </div> */}

      <Row className="g-4 mb-4 mt-2">
        <Col sm={6} md={4} lg={3}>
          <StatCardSkeleton />
        </Col>
        <Col sm={6} md={4} lg={3}>
          <StatCardSkeleton />
        </Col>
        <Col sm={6} md={4} lg={3}>
          <StatCardSkeleton />
        </Col>
        <Col sm={6} md={4} lg={3}>
          <StatCardSkeleton />
        </Col>
      </Row>

      <Row className="g-4 mb-4">
        <Col md={6} lg={8}>
          <ContactsBySourceSkeleton />
        </Col>
        <Col md={6} lg={4}>
          <LeadSourcesSkeleton />
        </Col>
      </Row>

      <Row className="g-4">
        <Col xs={12}>
          <AIRecommendationsSkeleton />
        </Col>
      </Row>

      {/* Chatbot toggle skeleton */}
      <div className="skeleton skeleton-chatbot-toggle" />
    </div>
  );
};

export default CrmDashboardSkeleton;
